"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sbGlobalTypes = void 0;
/**
 * Object used in preview.tsx of storybook to have a specific entry in the app bar for languages
 */
exports.sbGlobalTypes = {
    locale: {
        name: 'Locale',
        description: 'Internationalization locale',
        toolbar: {
            icon: 'globe',
            items: [
                { value: 'en', right: '🇺🇸', title: 'English' },
                { value: 'fr', right: '🇫🇷', title: 'Français' },
            ],
            showName: true,
        },
    },
};
//# sourceMappingURL=index.js.map